import { keyBy } from 'lodash';
import { fromJS, OrderedMap } from 'immutable';

import Constants from '../../constants';

const {
  Delivery,
  Deliveries,
  Location,
  LocationHour,
  Locations,
  PurchaseOrders,
  Vendor,
  Block,
} = Constants;

const initialState = fromJS({
  loading: false,
  error: null,
  count: 0,
  deliveries: {},
  availabilities: [],
  deliverablePurchaseOrders: {},
  locations: {},
  blocks: {},
});

const deliveryReducer = (state = initialState, action) => {
  const {
    availabilities,
    error,
    count,
    delivery,
    deliveryId,
    deliveries,
    locationId,
    location,
    locations,
    purchaseOrders,
    block,
    blocks,
    blockId,
    hourId,
  } = action;

  switch (action.type) {
    case Delivery.CREATE_DELIVERY_V2:
      return state.set('loading', true).set('error', null);
    case Delivery.CREATE_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Delivery.CREATE_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['deliveries', delivery.id], fromJS(delivery));
    case Delivery.GET_AVAILABILITIES:
      return state.set('loading', true).set('error', null);
    case Delivery.GET_AVAILABILITIES_ERROR:
      return state.set('loading', false).set('error', error);
    case Delivery.GET_AVAILABILITIES_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('availabilities', fromJS(availabilities));
    case Delivery.GET_DELIVERY:
      return state.set('loading', true).set('error', null);
    case Delivery.GET_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Delivery.GET_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['deliveries', delivery.id], fromJS(delivery));
    case PurchaseOrders.GET_DELIVERABLE_PURCHASE_ORDERS:
      return state.set('loading', true).set('error', null);
    case PurchaseOrders.GET_DELIVERABLE_PURCHASE_ORDERS_ERROR:
      return state.set('loading', false).set('error', error);
    case PurchaseOrders.GET_DELIVERABLE_PURCHASE_ORDERS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('deliverablePurchaseOrders', fromJS(keyBy(purchaseOrders, 'id')));
    case Deliveries.GET_DELIVERIES:
      return state.set('loading', true).set('error', null);
    case Deliveries.GET_DELIVERIES_ERROR:
      return state.set('loading', false).set('error', error);
    case Deliveries.GET_DELIVERIES_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('deliveries', fromJS(keyBy(deliveries, 'id')))
        .set('blocks', fromJS(keyBy(blocks, 'id')));
    case Delivery.UPDATE_DELIVERY_V2:
      return state
        .set('loading', true)
        .set('error', null)
        .setIn(['deliveries', deliveryId], fromJS(delivery))
        .setIn(['deliveries', deliveryId, 'loading'], true);
    case Delivery.CHECK_IN_DELIVERY:
      return state
        .set('loading', true)
        .set('error', null)
        .setIn(['deliveries', deliveryId, 'loading'], true);
    case Delivery.UPDATE_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Delivery.UPDATE_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['deliveries', delivery.id], fromJS(delivery))
        .setIn(['deliveries', delivery.id, 'loading'], false);
    case Delivery.REMOVE_DELIVERY:
      return state.set('loading', true).set('error', null);
    case Delivery.REMOVE_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Delivery.REMOVE_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .removeIn(['deliveries', deliveryId]);
    case Location.CREATE_LOCATION:
      return state.set('loading', true).set('error', null);
    case Location.CREATE_LOCATION_ERROR:
      return state.set('loading', false).set('error', error);
    case Location.CREATE_LOCATION_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case Location.GET_LOCATION:
      return state.set('loading', true).set('error', null);
    case Location.GET_LOCATION_ERROR:
      return state.set('loading', false).set('error', error);
    case Location.GET_LOCATION_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case Locations.GET_LOCATIONS:
      return state.set('loading', true).set('error', null);
    case Locations.GET_LOCATIONS_ERROR:
      return state.set('loading', false).set('error', error);
    case Locations.GET_LOCATIONS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('locations', fromJS(keyBy(locations, 'id')));
    case Location.UPDATE_LOCATION:
      return state.set('loading', true).set('error', null);
    case Location.UPDATE_LOCATION_ERROR:
      return state.set('loading', false).set('error', error);
    case Location.UPDATE_LOCATION_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case Location.REMOVE_LOCATION:
      return state.set('loading', true).set('error', null);
    case Location.REMOVE_LOCATION_ERROR:
      return state.set('loading', false).set('error', error);
    case Location.REMOVE_LOCATION_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .removeIn(['locations', locationId]);
    case Vendor.CREATE_VENDOR_DELIVERY_V2:
      return state.set('loading', true).set('error', null);
    case Vendor.CREATE_VENDOR_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.CREATE_VENDOR_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(
          ['deliveries'],
          state
            .get('deliveries')
            .setIn([delivery.id], fromJS(delivery))
            .sortBy((d) => d.starts_at)
            .reverse(),
        );
    case Vendor.REMOVE_VENDOR_DELIVERY:
      return state.set('loading', true).set('error', null);
    case Vendor.REMOVE_VENDOR_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.REMOVE_VENDOR_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .removeIn(['deliveries', deliveryId]);
    case Vendor.GET_VENDOR_DELIVERIES:
      return state.set('loading', true).set('error', null);
    case Vendor.GET_VENDOR_DELIVERIES_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.GET_VENDOR_DELIVERIES_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('deliveries', new OrderedMap(deliveries.map((d) => [d.id, d])))
        .set('count', count);
    case Vendor.GET_VENDOR_DELIVERY:
      return state.set('loading', true).set('error', null);
    case Vendor.GET_VENDOR_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.GET_VENDOR_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['deliveries', delivery.id], fromJS(delivery));
    case Vendor.UPDATE_VENDOR_DELIVERY:
      return state.set('loading', true).set('error', null);
    case Vendor.UPDATE_VENDOR_DELIVERY_V2:
      return state.set('loading', true).set('error', null);
    case Vendor.UPDATE_VENDOR_DELIVERY_ERROR:
      return state.set('loading', false).set('error', error);
    case Vendor.UPDATE_VENDOR_DELIVERY_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['deliveries', delivery.id], fromJS(delivery));
    case Block.CREATE_BLOCK:
      return state.set('loading', true).set('error', null);
    case Block.CREATE_BLOCK_ERROR:
      return state.set('loading', false).set('error', error);
    case Block.CREATE_BLOCK_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('deliveries', fromJS(keyBy(deliveries, 'id')))
        .set('blocks', fromJS(keyBy(blocks, 'id')));
    case Block.GET_BLOCK:
      return state.set('loading', true).set('error', null);
    case Block.GET_BLOCK_ERROR:
      return state.set('loading', false).set('error', error);
    case Block.GET_BLOCK_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['blocks', block.id], fromJS(block));
    case Block.GET_BLOCKS:
      return state.set('loading', true).set('error', null);
    case Block.GET_BLOCKS_ERROR:
      return state.set('loading', false).set('error', error);
    case Block.GET_BLOCKS_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('blocks', blocks);
    case Block.REMOVE_BLOCK:
      return state.set('loading', true).set('error', null);
    case Block.REMOVE_BLOCK_ERROR:
      return state.set('loading', false).set('error', error);
    case Block.REMOVE_BLOCK_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .removeIn(['blocks', blockId]);
    case Block.UPDATE_BLOCK:
      return state.set('loading', true).set('error', null);
    case Block.UPDATE_BLOCK_ERROR:
      return state.set('loading', false).set('error', error);
    case Block.UPDATE_BLOCK_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .set('deliveries', fromJS(keyBy(deliveries, 'id')))
        .set('blocks', fromJS(keyBy(blocks, 'id')));
    case LocationHour.CREATE_LOCATION_HOUR:
      return state.set('loading', true).set('error', null);
    case LocationHour.CREATE_LOCATION_HOUR_ERROR:
      return state.set('loading', false).set('error', error);
    case LocationHour.CREATE_LOCATION_HOUR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case LocationHour.GET_LOCATION_HOUR:
      return state.set('loading', true).set('error', null);
    case LocationHour.GET_LOCATION_HOUR_ERROR:
      return state.set('loading', false).set('error', error);
    case LocationHour.GET_LOCATION_HOUR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case LocationHour.UPDATE_LOCATION_HOUR:
      return state.set('loading', true).set('error', null);
    case LocationHour.UPDATE_LOCATION_HOUR_ERROR:
      return state.set('loading', false).set('error', error);
    case LocationHour.UPDATE_LOCATION_HOUR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .setIn(['locations', location.id], fromJS(location));
    case LocationHour.DELETE_LOCATION_HOUR:
      return state.set('loading', true).set('error', null);
    case LocationHour.DELETE_LOCATION_HOUR_ERROR:
      return state.set('loading', false).set('error', error);
    case LocationHour.DELETE_LOCATION_HOUR_SUCCESS:
      return state
        .set('loading', false)
        .set('error', null)
        .removeIn([
          'locations',
          locationId.toString(),
          'hours',
          hourId.toString(),
        ]);
    default:
      return state;
  }
};

export default deliveryReducer;
